module.exports = __webpack_public_path__ + "media/images/emblems/Kreuzlin-1d817a2957c0baad0419078290f40c32.GIF";